import DetailDepartament from '@/views/departament/DetailDepartament.vue'
import DepartamentDetailTabInfo from '@/components/departament/DetailTabDepartament.vue'
import demandRouter from '@/router/routers/departament/detail/demand'
import timelineRouter from '@/router/routers/departament/detail/timeline'
import workedHourRouter from '@/router/routers/departament/detail/workedHour'
import brandRouter from '@/router/routers/departament/detail/brand'
import contractRouter from '@/router/routers/departament/detail/contract'
import corporateRouter from '@/router/routers/departament/detail/corporate'
import collaboratorRouter from '@/router/routers/departament/detail/collaborator'
import FormUserViewDepartament from '@/views/user/FormUser'

const detailRouter = (beforeEnter, name, singleName, basePath, tabs, onlyManaged, options) => {
    return [
        {
            beforeEnter: beforeEnter,
            name: '',
            path: `/${basePath}/detalhe/:id`,
            meta: {
                requiresAuth: true,
                isEmployee: true,
                breadcrumb: true,
                layout: 'default'
            },
            props: true,
            component: DetailDepartament,
            children: [
                {
                    beforeEnter: beforeEnter,
                    name: `${name}DetalheAbaInfo`,
                    path: '',
                    meta: {
                        requiresAuth: true,
                        isEmployee: true,
                        layout: 'default',
                        basePath: basePath,
                        singleName: singleName.toLowerCase(),
                        tabs
                    },
                    props: true,
                    component: DepartamentDetailTabInfo
                },
                demandRouter(beforeEnter, name, singleName, basePath, tabs),
                timelineRouter(beforeEnter, name, singleName, basePath, tabs),
                workedHourRouter(beforeEnter, name, singleName, basePath, tabs),
                brandRouter(beforeEnter, name, singleName, basePath, tabs),
                contractRouter(beforeEnter, name, singleName, basePath, tabs),
                corporateRouter(beforeEnter, name, singleName, basePath, tabs),
                collaboratorRouter(beforeEnter, name, singleName, basePath, tabs)
            ]
        },
        {
            beforeEnter: beforeEnter,
            name: `${singleName}DetalheAbaUsuarioCadastrar`,
            path: `/${basePath}/detalhe/:requesterType/colaborador/cadastrar`,
            meta: {
                requiresAuth: true,
                isEmployee: true,
                layout: 'default'
            },
            props: true,
            component: FormUserViewDepartament
        },
        {
            beforeEnter: beforeEnter,
            name: `${singleName}DetalheAbaUsuarioEditar`,
            path: `/${basePath}/detalhe/:requesterType/colaborador/editar/:id`,
            meta: {
                requiresAuth: true,
                isEmployee: true,
                layout: 'default'
            },
            props: true,
            component: FormUserViewDepartament
        }
    ]
}

export default detailRouter
